import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { PickerDialog } from '@wit-support/ui';
import { filterTemplatesByName, TemplatePicker } from '@wit-support/ui-domain';
import { ScheduleControl } from '../scheduled/schedule-control.js';
import { fetchTemplates } from './bulk-data.js';
import { useBulkAction } from './use-bulk-action.js';
/**
 * Bulk «По таймеру» dialog: pick ONE template, then a schedule (preset or custom
 * datetime, via the shared `ScheduleControl`). Picking the schedule fires the
 * bulk `schedule_email` action — one scheduled email per selected conversation.
 */
export function BulkScheduleDialog({ open, conversationIds, onOpenChange, }) {
    const [search, setSearch] = useState('');
    const [templateId, setTemplateId] = useState(null);
    const query = useQuery({
        queryKey: ['templates'],
        queryFn: fetchTemplates,
        enabled: open,
        staleTime: 60_000,
    });
    // useBulkAction owns the post-apply selection handling; the dialog just closes.
    const mut = useBulkAction(() => {
        onOpenChange(false);
        setTemplateId(null);
        setSearch('');
    });
    const count = conversationIds.length;
    const filtered = useMemo(() => filterTemplatesByName(query.data, search), [query.data, search]);
    function handleSchedule(scheduleFor) {
        if (!templateId || count === 0)
            return;
        mut.mutate({
            conversationIds,
            action: {
                type: 'schedule_email',
                templateId: templateId,
                scheduleFor,
            },
        });
    }
    return (_jsx(PickerDialog, { open: open, onOpenChange: onOpenChange, busy: mut.isPending, onReset: () => {
            setTemplateId(null);
            setSearch('');
        }, title: "\u0417\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u043E", description: _jsxs(_Fragment, { children: ["\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0430\u0431\u043B\u043E\u043D, \u0437\u0430\u0442\u0435\u043C \u0432\u0440\u0435\u043C\u044F \u2014 \u043F\u043E \u043E\u0434\u043D\u043E\u043C\u0443 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u043E\u043C\u0443 \u043F\u0438\u0441\u044C\u043C\u0443 \u043D\u0430 \u043A\u0430\u0436\u0434\u044B\u0439 \u0438\u0437 ", count, ' ', count === 1 ? 'диалога' : 'выбранных диалогов', "."] }), footer: _jsx(ScheduleControl, { onSchedule: handleSchedule, disabled: !templateId || mut.isPending || count === 0 }), children: _jsx(TemplatePicker, { templates: filtered, isLoading: query.isLoading, search: search, onSearchChange: setSearch, onPick: (t) => setTemplateId(t.id), selectedId: templateId, disabled: mut.isPending, listContainerClassName: "min-h-0 flex-1 overflow-auto", listClassName: "flex flex-col gap-1.5", nameClassName: "w-full truncate text-sm font-medium", emptyMessage: "\u0428\u0430\u0431\u043B\u043E\u043D\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B." }) }));
}
//# sourceMappingURL=bulk-schedule-dialog.js.map